export const TOP_BENEFITS_LOOKUP_CODE = ['medical', 'dental', 'vision'];
export const DECLINE_COVERAGE_LOOKUP_CODE = 'decline';
